// Clases de Store
import createStore, { UiStore } from '@pjn/vue-core/store';
import { authService } from '@/services';

// Adaptador a DevTools (para desarrollo)
import devtoolPlugin from '@pjn/vue-core/store/devTools';

// Seguridad
import { AuthStore } from '@pjn/vue-core/store/AuthStore';
// Otros stores
import MagistradoStore from './MagistradoStore';
import ExpedienteStore from './ExpedienteStore';
import DenunciaStore from './DenunciaStore';
import NotificacionesStore from './NotificacionesStore';
import ConfiguracionStore from './ConfiguracionStore';

// Instanciacion y exportacion de los Store
export const uiStore = new UiStore(); // Crea y exporta el UiStore
export const authStore = new AuthStore();
export const magistradoStore = new MagistradoStore();
export const expedienteStore = new ExpedienteStore();
export const denunciaStore = new DenunciaStore();
export const notificacionesStore = new NotificacionesStore();
export const configuracionStore = new ConfiguracionStore();

authStore.setService(authService);

// Crear otros Submodulos

export const store = createStore(
  {
    auth: authStore,
    ui: uiStore,
    // Inyectar los otros submodulos
  
  },
  {
    init() {
      // Logica a ejecutar al iniciar la app
      // (cargar datos iniciales publicos en el store)
    },
    async initAfterSecurity() {
      // Logica a ejecutar al luego de obtener el usuario
      // (cargar datos iniciales que requieren autenticacion en el store)

      if((authStore.user)){
      if((window.location.pathname.search('/admin') === -1) )
        window.location.replace("/admin")

      notificacionesStore.load()
     }
     
    }
  }
);

// Integra a DevTools (solo en desarrollo)
devtoolPlugin(store, { strict: true });
